/* eslint-disable jsx-a11y/media-has-caption */
import ActionsLayout from '@/components/MatchLayout'
import { useMatch } from '@/hooks/swr/useMatch'
import { usePlayers } from '@/hooks/swr/usePlayer'
import useRooms from '@/hooks/swr/useRoom'
import { useAllRounds } from '@/hooks/swr/useRound'
import { useTeams } from '@/hooks/swr/useTeam'
import { httpDelete, post } from '@/utils/request'
import { RoomStatusNum, isSinglePlayerMatch, roomColor, roomStatus } from '@/utils/utils'
import { Button, Input, Modal, message } from 'antd'
import { ReactElement, useMemo, useState } from 'react'
import { debounce } from 'lodash-es'
import { GetServerSideProps } from 'next/types'

const AllRounds = ({ match_id }) => {
  const { data: rounds, mutate: mutateRounds } = useAllRounds(match_id)
  const { data: tables } = useRooms(match_id, 'sum')
  const { data: teams } = useTeams(match_id)
  const { data: players } = usePlayers(match_id)
  const { data: match } = useMatch(match_id)
  const [roundInfo, setRoundInfo] = useState(undefined)
  const [filterKeywords, setFilterKeywords] = useState('')

  const RoomNameMap = useMemo(() => {
    const map = {}
    tables.forEach((table) => {
      map[table.id] = table.name
    })
    return map
  }, [tables])

  const TeamMap = useMemo(() => {
    const map = {}
    teams.forEach((team) => {
      map[team.id] = team
    })
    return map
  }, [teams])

  const PlayerMap = useMemo(() => {
    const map = {}
    players.forEach((player) => {
      map[player.id] = player
    })
    return map
  }, [players])

  const filteredRounds = useMemo(() => {
    if (!filterKeywords) {
      return rounds
    }
    return rounds.filter(
      (r) =>
        PlayerMap[r.player1_id]?.name?.includes(filterKeywords) ||
        PlayerMap[r.player2_id]?.name?.includes(filterKeywords) ||
        PlayerMap[r.player3_id]?.name?.includes(filterKeywords) ||
        PlayerMap[r.player4_id]?.name?.includes(filterKeywords) ||
        PlayerMap[r.player1_id]?.mobile?.includes(filterKeywords) ||
        PlayerMap[r.player2_id]?.mobile?.includes(filterKeywords) ||
        PlayerMap[r.player3_id]?.mobile?.includes(filterKeywords) ||
        PlayerMap[r.player4_id]?.mobile?.includes(filterKeywords) ||
        TeamMap[r.team1_id]?.name?.includes(filterKeywords) ||
        TeamMap[r.team2_id]?.name?.includes(filterKeywords) ||
        TeamMap[r.team1_id]?.name_user1?.includes(filterKeywords) ||
        TeamMap[r.team2_id]?.name_user1?.includes(filterKeywords) ||
        TeamMap[r.team1_id]?.name_user2?.includes(filterKeywords) ||
        TeamMap[r.team2_id]?.name_user2?.includes(filterKeywords) ||
        TeamMap[r.team1_id]?.mobile_user1?.includes(filterKeywords) ||
        TeamMap[r.team2_id]?.mobile_user1?.includes(filterKeywords) ||
        TeamMap[r.team1_id]?.mobile_user2?.includes(filterKeywords) ||
        TeamMap[r.team2_id]?.mobile_user2?.includes(filterKeywords)
    )
  }, [PlayerMap, TeamMap, filterKeywords, rounds])

  return (
    <div className="m-2">
      <div className="flex">
        <div>
          <Button
            className="mb-2"
            onClick={() => {
              httpDelete('users/rounds/delete_unusual_rounds', { match_id }).then((res) => {
                if (res.ok) {
                  message.info('成功')
                } else {
                  message.info(res.message)
                }
                mutateRounds()
              })
            }}
          >
            删除异常轮次
          </Button>

          <Button
            className="ml-2"
            onClick={() => {
              post('users/rounds/recount_all_teams_score', { match_id }).then((res) => {
                if (res.ok) {
                  message.info('成功')
                } else {
                  message.info(res.message)
                }
                mutateRounds()
              })
            }}
          >
            重新计算比分
          </Button>
          <Button
            className="ml-2"
            onClick={() => {
              post('users/rounds/refresh_all_rooms', { match_id }).then((res) => {
                if (res.ok) {
                  message.info('成功')
                } else {
                  message.info(res.message)
                }
                mutateRounds()
              })
            }}
          >
            重置桌次状态
          </Button>
        </div>
        <Input.Search
          className="ml-auto w-40"
          placeholder="搜索"
          onChange={debounce((e) => {
            setFilterKeywords(e.target.value)
          }, 500)}
        />
      </div>
      <div>
        {filteredRounds.map((round) => {
          return (
            <div key={round.id} className="my-1 grid grid-cols-12 rounded bg-white p-2 text-lg">
              <div>{RoomNameMap[round.room_id]}</div>
              {isSinglePlayerMatch(match.match_type) ? (
                <>
                  <div className="col-span-1">{PlayerMap[round.player1_id]?.name}</div>
                  <div className="col-span-1">{PlayerMap[round.player2_id]?.name}</div>
                  <div className="col-span-1">{PlayerMap[round.player3_id]?.name}</div>
                  <div className="col-span-1">{PlayerMap[round.player4_id]?.name}</div>
                </>
              ) : (
                <>
                  <div className="col-span-2">
                    {TeamMap[round.team1_id]?.name}:{TeamMap[round.team1_id]?.name_user1},{TeamMap[round.team1_id]?.name_user2}
                  </div>
                  <div className="col-span-2">
                    {TeamMap[round.team2_id]?.name}:{TeamMap[round.team2_id]?.name_user1},{TeamMap[round.team2_id]?.name_user2}
                  </div>
                </>
              )}

              <div>第{round.turn}轮</div>
              {isSinglePlayerMatch(match.match_type) ? (
                <div>
                  {round.player1_rank}:{round.player2_rank}:{round.player3_rank}:{round.player4_rank}
                </div>
              ) : (
                <div>
                  {round.team1_rank}:{round.team2_rank}
                </div>
              )}
              <div className={`${roomColor[RoomStatusNum[round.status]]}`}>{roomStatus[RoomStatusNum[round.status]]}</div>
              <div>
                <Button type="primary" onClick={() => setRoundInfo(round)}>
                  详情
                </Button>
                <Button
                  danger
                  className="ml-2"
                  onClick={() =>
                    Modal.confirm({
                      content: '您确定删除本对局吗，此操作不可逆',
                      onOk: () => {
                        httpDelete('users/rounds/delete_one_round', { round_id: round.id }).then((res) => {
                          if (res.ok) {
                            message.info('成功')
                          }
                          mutateRounds()
                        })
                      },
                    })
                  }
                >
                  删除
                </Button>
              </div>
            </div>
          )
        })}
      </div>
      <Modal open={!!roundInfo} onCancel={() => setRoundInfo(undefined)} footer={null} className="w-4/5">
        {JSON.stringify(roundInfo)}
      </Modal>
    </div>
  )
}

AllRounds.getLayout = function getLayout(children: ReactElement) {
  return <ActionsLayout>{children}</ActionsLayout>
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  return {
    props: {
      match_id: ctx.query.match_id,
    },
  }
}
export default AllRounds
